import { Route } from 'react-router';

export function getGlobalResourceRoutes(enabled: boolean) {
  if (enabled) {
    return (
      <>
        <Route id="resources-teams" path="resources/teams" lazy={() => import('routes/resources/teams/teams.route')} />
        <Route
          id="resources-current-user"
          path="resources/current-user"
          lazy={() => import('routes/resources/current-user/current-user.route')}
        />
      </>
    );
  }

  return null;
}
